export * from './card.styled.base';
